import React, { FC, PropsWithChildren, useEffect } from 'react';

import { Error, Flex, HSLoader, Layout } from '../components';
import { useGetOrganizationDocumentFromFirestore, useQueryHelper } from '../queries';
import { useOrganizationState } from '../state';

export const OrganizationContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const { setOrganizationData } = useOrganizationState();
  const domain = window.location.hostname;
  const isLocal = domain === 'localhost' || /^192\.168\./.test(domain) || /^10\./.test(domain);
  const code = isLocal ? 'magnahotel' : domain.split('.')[0];
  const org = useGetOrganizationDocumentFromFirestore('code', code);
  const { data: organization, refetch } = org;
  const { isLoading, isError } = useQueryHelper({ queries: [org] });

  useEffect(() => {
    if (organization) {
      setOrganizationData(organization);
    }
  }, [organization]);

  if (isLoading) {
    return (
      <Flex fullHeight itemAlign="center" justifyContent="center"><HSLoader size={80} /></Flex>
    );
  }

  if (isError) {
    return (
      <Error
        errorMessage="Organization not found, please try again...."
        action={refetch}
      />
    );
  }

  return (
    <Layout key="organization-context-provider">
      {children}
    </Layout>
  );
};
